import { useEffect, useState } from 'react';

import EventBusInstance from '@core/eventbus';
import { uefatvClientEvents } from '@core/uefatvClient/domain';
import { Warn } from '@utilities/logging';

export const useHandleError = () => {
  const [error, setError] = useState();

  const handleError = (error) => {
    // todo handle error and redirect
    Warn('uefatv-Error', error);
    if (error?.status === 422) {
      setError(error);
    }
  };
  useEffect(() => {
    EventBusInstance.on(uefatvClientEvents.ERROR, handleError, this);

    return () => {
      EventBusInstance.off(uefatvClientEvents.ERROR, handleError, this);
    };
  }, []);

  return error;
};
